"use strict";
const _ = require('lodash');
function calculateDisposableSalesUnits(article) {
    const { stockInfoOnOfcList, colliSize, orderUnit } = article;
    if (!stockInfoOnOfcList || stockInfoOnOfcList.length === 0) {
        return 0;
    }
    const displayDisposableQuantity = stockInfoOnOfcList[0].displayDisposableQuantity;
    if (orderUnit === 'package') {
        return Math.floor(displayDisposableQuantity / colliSize);
    }
    return displayDisposableQuantity;
}
function isBatchAlwaysOrderableOnMyOfc(pricedArticle) {
    const { stockInfoOnOfcList, myOrderFullfillmentCenter } = pricedArticle;
    return (stockInfoOnOfcList &&
        myOrderFullfillmentCenter &&
        stockInfoOnOfcList.some(batch => batch.isAlwaysOrderable &&
            batch.orderFullfillmentCenter.id === myOrderFullfillmentCenter.id));
}
function warehouseStatus(article) {
    const { active, isAvailableForPreorder, myOrderFullfillmentCenter, markedAsOutOfStock, isAlwaysOrderable, } = article;
    const displayDisposableQuantity = calculateDisposableSalesUnits(article);
    if (!myOrderFullfillmentCenter || _.isEmpty(myOrderFullfillmentCenter)) {
        return {
            isPossibleToOrder: false,
            isAvailableInStock: false,
            text: 'Tillfälligt slut',
            color: 'danger',
        };
    }
    if (!active) {
        return {
            isPossibleToOrder: false,
            isAvailableInStock: false,
            text: 'Inaktiv artikel',
            color: 'danger',
        };
    }
    if (markedAsOutOfStock) {
        return {
            isPossibleToOrder: false,
            isAvailableInStock: false,
            text: 'Tillfälligt slut',
            color: 'danger',
        };
    }
    if (isAvailableForPreorder) {
        // THERE IS SOMETHING WIERD ABOUT THIS
        return {
            isPossibleToOrder: true,
            isAvailableInStock: false,
            text: 'Förbokningsartikel - Boka nu',
            color: 'primary',
        };
    }
    if (isAlwaysOrderable ||
        isBatchAlwaysOrderableOnMyOfc(article) ||
        displayDisposableQuantity >= 25) {
        return {
            isPossibleToOrder: true,
            isAvailableInStock: true,
            text: 'Finns i lager',
            color: 'success',
        };
    }
    if (displayDisposableQuantity < 25 && displayDisposableQuantity > 0) {
        return {
            isPossibleToOrder: true,
            isAvailableInStock: true,
            text: 'Begränsat antal kvar',
            color: 'warning',
        };
    }
    return {
        isPossibleToOrder: false,
        isAvailableInStock: false,
        text: 'Tillfälligt slut',
        color: 'danger',
    };
}
function deliveryStatus(article) {
    const disposableSalesUnits = calculateDisposableSalesUnits(article);
    if (disposableSalesUnits <= 0 && article.onCopack) {
        return `Leveranstid 3-7 dagar`;
    }
    return '';
}
module.exports = {
    warehouseStatus,
    deliveryStatus,
    calculateDisposableSalesUnits,
};
